import React from 'react'
import { Table ,Divider,Progress} from 'antd';
import {
    DesktopOutlined } from '@ant-design/icons';
const columns = [
  {
    title: 'Course',
    dataIndex: 'name',
    width: 150,
  },

  {   progress : 'progress',
      dataIndex : 'progress'
  }
];

const data = [
    {code : 1,name : 'CAP361',progress :<Progress percent={70}  status="exception" />},
    {code : 2,name : 'CAP363',progress :<Progress percent={100} />},
    {code : 3,name : 'CAP366',progress :<Progress percent={10} />},
    {code : 4,name : 'CAP361',progress :<Progress percent={70} status="active" />},
    {code : 5,name : 'CAP363',progress :<Progress percent={80}  strokeColor="orange" />},
    {code : 6,name : 'CAP366',progress :<Progress percent={10} />},
];


const MyCourses =() => {
    return (
        <>
       <Divider
        orientation="left" plain style={{ fontSize: '16px', color: '#08c' }}>
            <DesktopOutlined  style={{ fontSize: '16px', color: '#08c' }} >
                </DesktopOutlined> &nbsp;&nbsp;My Courses & Attendance</Divider>
    <Table columns={columns} 
    dataSource={data}
     pagination={false}
      scroll={{ y: 240 }} >
  
          </Table>
          <br   />
          </>
)}

export default MyCourses